import { render } from "./WordBreakColumn.vue?vue&type=template&id=31869973&ts=true"
import script from "./WordBreakColumn.vue?vue&type=script&lang=ts"
export * from "./WordBreakColumn.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__